<script lang="ts" setup>
const { accountQuery } = useCustomerModuleQuery()
const { data: status } = accountQuery.getStatus()
</script>

<template>
  <div v-if="status === 'pending'" class="flex items-stretch gap-3 p-4 bg-blue-100 rounded mb-4">
    <div class="hidden md:grid shrink-0 place-content-center bg-blue-50 size-11 rounded">
      <Icon name="material-symbols:pending-outline" size="24" />
    </div>

    <div>
      <p class="text-base font-semibold">
        {{ $t('customerModule.statusBar.pending.title') }}
      </p>
      <p>
        {{ $t('customerModule.statusBar.pending.text') }}
      </p>
    </div>
  </div>
</template>
